export default "__VITE_ASSET__Ea_acjh0__"